import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { BRAND } from '@/config/brand';
import { MAP_SALE, MAP_RENT } from '@/config/navLinks';
import { Logo } from '@/components/common/Logo';

const COLS = [
  {
    title: 'Buy',
    links: [
      ['Homes for sale', MAP_SALE],
      ['New construction', `${MAP_SALE}&propertyCondition=New%20Construction`],
      ['Open houses', MAP_SALE],
      ['Coming soon', '/map?status=Cs&listingType=Sale'],
      ['Recent home sales', '/map?status=Sld&listingType=Sale'],
    ],
  },
  {
    title: 'Rent',
    links: [
      ['Apartments', `${MAP_RENT}&propertyType=apartments`],
      ['Houses for rent', `${MAP_RENT}&propertyType=single-family`],
      ['All rentals', MAP_RENT],
      ['Renter guide', '/help'],
      ['Affordability', '/help'],
    ],
  },
  {
    title: 'Sell',
    links: [
      ['List your home', '/dashboard/my-listings'],
      ['Pricing & tools', '/advertise'],
      ["Find a seller's agent", '/agents'],
      ['Advertise', '/advertise'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['About us', '/about'],
      ['Contact', '/contact'],
      ['Help center', '/help'],
    ],
  },
];

export const Footer = () => (
  <footer className="border-t border-slate-200 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid grid-cols-2 gap-8 md:grid-cols-6">
        <div className="col-span-2">
          <Logo />
          <p className="mt-3 text-sm text-slate-600 max-w-xs">{BRAND.tagline}. Search millions of listings, connect with trusted local agents, and close with confidence.</p>
          <div className="mt-4 space-y-1.5 text-sm text-slate-600">
            <a href={`mailto:${BRAND.support.email}`} className="flex items-center gap-2 hover:text-blue-700"><Mail size={16} />{BRAND.support.email}</a>
            {BRAND.support.phone ? (
              <a href={`tel:${BRAND.support.phone.replace(/\D/g, '')}`} className="flex items-center gap-2 hover:text-blue-700"><Phone size={16} />{BRAND.support.phone}</a>
            ) : null}
          </div>
          <div className="mt-5 flex flex-col gap-2.5">
            <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">Get the app</p>
            <div className="flex flex-wrap gap-2">
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store">
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Download on the App Store"
                  className="h-10 w-auto"
                />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play">
                <img
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  alt="Get it on Google Play"
                  className="h-10 w-auto"
                />
              </a>
            </div>
          </div>
        </div>
        {COLS.map((col) => (
          <div key={col.title}>
            <h4 className="text-sm font-semibold text-slate-900">{col.title}</h4>
            <ul className="mt-3 space-y-2">
              {col.links.map(([label, to]) => (
                <li key={label}><Link to={to} className="text-sm text-slate-600 hover:text-blue-700 transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
    <div className="border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-5 pb-4">
        <p className="text-xs text-slate-400 leading-relaxed">
          IDX information is provided exclusively for consumers&apos; personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information deemed reliable but not guaranteed to be accurate. Buyer to verify all information. Listing information updated every 15 minutes.{' '}
          <Link to="/terms" className="underline hover:text-blue-600">Terms of use</Link>
          {' & '}
          <Link to="/privacy" className="underline hover:text-blue-600">Privacy Policy</Link>
          , Florida Privacy Info. Copyright &copy; 2025&ndash;2026 Lokation Real Estate. All rights reserved.{' '}
          MLS# 276802705.
        </p>
        <p className="mt-1.5 text-xs text-slate-400 leading-relaxed">
          {BRAND.name} is committed to ensuring accessibility for individuals with disabilities. We are continuously working to improve the accessibility of our web experience for everyone. We welcome feedback and accommodation requests &mdash; please submit them <Link to="/contact" className="underline hover:text-blue-600">here</Link>.
        </p>
        <div className="mt-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">{BRAND.name}. All rights reserved. Listings shown are for demonstration only.</p>
          <div className="flex items-center gap-4 text-xs text-slate-500">
            <Link to="/privacy" className="hover:text-blue-700">Privacy</Link>
            <Link to="/terms" className="hover:text-blue-700">Terms</Link>
            <Link to="/cookies" className="hover:text-blue-700">Cookies</Link>
            <Link to="/delete-account" className="hover:text-blue-700">Delete account</Link>
          </div>
        </div>
      </div>
    </div>
  </footer>
);
